import './style.scss';

export function branch_image_block() {
    const block = document.querySelector('.branch_image_block');
    if (!block) return;
}
